import { SET_USER_INFO, SET_AUTH_PROPERTY } from 'store/actions/auth';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_AUTH_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [SET_USER_INFO]: (state, userInfo) => {
    state.userInfo = userInfo;
  }
};
